export class Category {
    constructor(id = -1, name = '') {
        this.id = id;
        this.name = name;
        this.iconName = name.toLowerCase();
    }

    getId() {
        return this.id;
    }

    setId(id=-1) {
        this.id = id;
    }

    getName() {
        return this.name;
    }

    setName(name='') {
        this.name = name;
        this.setIconName( name.toLowerCase() );
    }

    getIconName() {
        return this.iconName;
    }

    setIconName(iconName='') {
        this.iconName = iconName;
    }

    toFormObject() {
        return {
            id: this.id,
            name: this.name
        };
    }
}